import {
  ARRAY_UTILS_SORT_ASC,
  getOrderedByObjectStringProperty,
} from '../../utils/ArrayUtils';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import { TOTAL_ITEMS_FOR_PAGE } from '../../utils/PaginationUtils';
import {
  CHANGED_ASSESSOR_EDITING_VALUE_ACTION,
  CHANGE_ASSESSOR_STATUS_ACTION,
  CLEARED_ASSESSORES_ACTION,
  CLEARED_ASSESSORES_BY_COOP_ACTION,
  CLEARED_ASSESSORES_PAGE_ACTION,
  CLEARED_ASSESSOR_ACTION,
  CLEAR_NAME_ACTION,
  LOADED_ASSESSORES_ACTION,
  LOADED_ASSESSORES_BY_COOPS_ACTION,
  LOADED_ASSESSORES_BY_COOP_ACTION,
  LOADED_ASSESSORES_PAGE_ACTION,
  LOADED_ASSESSOR_ACTION,
  LOADING_ASSESSORES_ACTION,
  LOADING_ASSESSORES_BY_COOPS_ACTION,
  LOADING_ASSESSORES_BY_COOP_ACTION,
  LOAD_PROGRAMAS_ATIVOS_FAILURE,
  LOAD_PROGRAMAS_ATIVOS_REQUEST,
  LOAD_PROGRAMAS_ATIVOS_SUCCESS,
  REMOVING_ASSESSOR_ACTION,
  RESETED_ASSESSORES,
  SET_NAME,
} from './AssessoresActions';

const PAGE_LIST_INITIAL_STATE = {
  busca: '',
  page: -1,
  totalElements: 0,
  totalPages: 0,
  elements: [],
};

const ASSESSOR_EDITING_NOT_NULL_PROPS = [
  'nome',
  'celular',
  'email',
  'mae',
  'areaEstudo',
  'dataNascimento',
  'rg',
  'cpf',
  'formacao',
  'cidades'
];

const ASSESSOR_EDITING_INITIAL_STATE = {
  nome: '',
  celular: '',
  email: '',
  mae: '',
  dataNascimento: '',
  rg: '',
  cpf: '',
  situacao: -1,
  areaEstudo: '',
  cooperativas: [],
  cooperativasGestor: [],
  formacao: [],
  idEmpresa: null,
  estado: '',
  idEstado: -1,
  cidades: [],
  cidadesSelecionadas: []

};

const INITIAL_STATE = {
  assessorEditing: ASSESSOR_EDITING_INITIAL_STATE,
  assessorName: null,
  cordenadorName: null,
  error: null,
  list: [],
  listByCoop: [],
  listByCoops: [],
  loading: false,
  loadingList: false,
  loadingListByCoop: false,
  loadingListByCoops: false,
  pageList: PAGE_LIST_INITIAL_STATE,
  pageSize: TOTAL_ITEMS_FOR_PAGE,
  professorName: null,
  programas: [],
};

const getRefreshedPageList = (lastPageList, newPageList) => {
  return {
    ...lastPageList,
    busca: newPageList.busca,
    page: newPageList.page,
    totalElements: newPageList.totalElements,
    totalPages: newPageList.totalPages,
    elements: [...lastPageList.elements, ...newPageList.elements],
  };
};

const getChangedStatusList = (pageList, cpf, status) => {
  let newPageList = {
    ...pageList,
    elements: [],
  };
  pageList.elements.map((element, index) => {
    if (element.cpf === cpf) {
      newPageList.elements.push({
        ...element,
        status,
      });
    } else {
      newPageList.elements.push(element);
    }
    return index;
  });
  return newPageList;
};

export default function AssessoresReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESETED_ASSESSORES:
      return {
        ...INITIAL_STATE,
      };
    case SET_NAME:
      if (action.payload.type === 'assessorName') {
        return {
          ...state,
          assessorName: action.payload.value,
          professorName: null,
          cordenadorName: null,
        };
      } else if (action.payload.type === 'professorName') {
        return {
          ...state,
          professorName: action.payload.value,
          assessorName: null,
          cordenadorName: null,
        };
      } else if (action.payload.type === 'cordenadorName') {
        return {
          ...state,
          cordenadorName: action.payload.value,
          professorName: null,
          assessorName: null,
        };
      }
      return state;
    case CLEAR_NAME_ACTION:
      return {
        ...state,
        assessorName: null,
        professorName: null,
        cordenadorName: null,
      };
    case CLEARED_ASSESSORES_ACTION:
      return { ...state, list: [] };
    case LOADING_ASSESSORES_ACTION:
      return { ...state, loadingList: action.payload };
    case LOADED_ASSESSORES_ACTION:
      return {
        ...state,
        list: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case CLEARED_ASSESSORES_BY_COOP_ACTION:
      return {
        ...state,
        listByCoop: [],
      };
    case LOADING_ASSESSORES_BY_COOP_ACTION:
      return {
        ...state,
        loadingListByCoop: action.payload,
      };
    case LOADED_ASSESSORES_BY_COOP_ACTION:
      return {
        ...state,
        listByCoop: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADING_ASSESSORES_BY_COOPS_ACTION:
      return {
        ...state,
        loadingListByCoops: action.payload,
      };
    case LOADED_ASSESSORES_BY_COOPS_ACTION:
      return {
        ...state,
        listByCoops: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ASSESSORES_PAGE_ACTION:
      return {
        ...state,
        pageList: getRefreshedPageList(state.pageList, action.payload),
      };
    case LOADED_ASSESSOR_ACTION:
      return {
        ...state,
        assessorEditing: {
          ...transformNullIntoEmpty(
            action.payload,
            ASSESSOR_EDITING_NOT_NULL_PROPS
          ),
          formacaoAcademica:
            action.payload.formacaoAcademica === null
              ? -1
              : action.payload.formacaoAcademica,
        },
      };
    case CLEARED_ASSESSOR_ACTION:
      return {
        ...state,
        assessorEditing: ASSESSOR_EDITING_INITIAL_STATE,
      };
    case CHANGE_ASSESSOR_STATUS_ACTION:
      return {
        ...state,
        pageList: getChangedStatusList(
          state.pageList,
          action.payload.cpf,
          action.payload.status
        ),
      };
    case CLEARED_ASSESSORES_PAGE_ACTION:
      return { ...state, pageList: PAGE_LIST_INITIAL_STATE };
    case CHANGED_ASSESSOR_EDITING_VALUE_ACTION:
      return {
        ...state,
        assessorEditing: {
          ...state.assessorEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case REMOVING_ASSESSOR_ACTION:
      return {
        ...state,
        removingAssessor: action.payload,
      };
    case LOAD_PROGRAMAS_ATIVOS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_PROGRAMAS_ATIVOS_SUCCESS:
      return {
        ...state,
        loading: false,
        programas: action.payload,
      };
    case LOAD_PROGRAMAS_ATIVOS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
